import React from 'react';

interface IProps {
  children: React.ReactNode;
  title?: string;
}

const KDSLayout: React.FC<IProps> = ({ children, title }) => {
  return (
    <div className="AuthCont grid grid-cols-12 gap-2 min-h-screen overflow-hidden">
      <div className="AuthCont--inner col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4 max-h-screen overflow-scroll">
        <div className="px-10 py-10 flex flex-col justify-between min-h-screen  mx-auto max-w-[477px]">
          {title && <h1 className="text-4xl font-semibold mb-5">{title}</h1>}
          {children}
        </div>
      </div>
    </div>
  );
};

export default React.memo(KDSLayout);
